var FrameType;

(function (FrameType) {
  FrameType["Pause"] = "Pause";
  FrameType["Delay"] = "Delay";
  FrameType["Set"] = "Set";
  FrameType["Tween"] = "Tween";
})(FrameType || (FrameType = {}));

var totalDuration = frames => Math.max(...frames.map(frame => frame.startAt + frame.duration));

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

var mapValues = (object, mapFunction) => Object.fromEntries(Object.entries(object).map(_ref => {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return [key, mapFunction(value)];
}));

var limit = function limit(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Math.min(Math.max(value, min), max);
};

var shouldSkipFrame = (currentTime, currentTimeIndex, frame) => {
  if (frame.startAt > currentTime) return true;
  if (frame.startAt === currentTime && frame.startIndex > currentTimeIndex) return true;
  return false;
};

var render = (currentTime, currentTimeIndex, frames) => {
  for (var i = frames.length - 1; i >= 0; i--) {
    var frame = frames[i];

    switch (frame.type) {
      case FrameType.Tween:
        frame.renderer(mapValues(frame.values, val => val(0)));
        break;

      case FrameType.Set:
        frame.renderer(mapValues(frame.values, val => val[0]));
        break;
    }
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var frame = _step.value;
      if (shouldSkipFrame(currentTime, currentTimeIndex, frame)) return "continue";

      switch (frame.type) {
        case FrameType.Tween:
          frame.renderer(mapValues(frame.values, val => {
            var n = limit((currentTime - frame.startAt) / frame.duration);
            return val(frame.easing(n));
          }));
          break;

        case FrameType.Set:
          frame.renderer(mapValues(frame.values, val => {
            var _val = _slicedToArray(val, 2),
                off = _val[0],
                on = _val[1];

            return currentTime >= frame.startAt + frame.duration ? on : off;
          }));
          break;
      }
    };

    for (var _iterator = frames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var findTextStepTime = (prevTime, prevTimeIndex, nextTime, total, frames) => {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = frames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var frame = _step.value;

      if (frame.type === FrameType.Pause && frame.startAt >= prevTime && frame.startAt <= nextTime && frame.startIndex > prevTimeIndex) {
        return {
          nextTime: frame.startAt,
          nextTimeIndex: frame.startIndex,
          pause: true,
          end: false
        };
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (nextTime > total) {
    return {
      nextTime: total,
      nextTimeIndex: 0,
      pause: true,
      end: true
    };
  }

  return {
    nextTime,
    nextTimeIndex: 0,
    pause: false,
    end: false
  };
}; // @TODO make this immutable


var prepareFrames = frames => {
  frames.sort((a, b) => a.startAt - b.startAt);

  for (var i = 0; i < frames.length; i++) {
    var frame = frames[i];
    var prevFrame = frames[i - 1];
    var nextFrame = frames[i + 1];

    if (prevFrame && prevFrame.startAt === frame.startAt) {
      frame.startIndex = prevFrame.startIndex + 1;
    } else if (nextFrame && nextFrame.startAt === frame.startAt) {
      frame.startIndex = 1;
    }
  }

  return frames;
};

var lightTrails = function lightTrails(trailFunction) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentTime = 0;
  var currentTimeIndex = 0;
  var playing = false;
  var frames = prepareFrames(trailFunction(0));
  var total = totalDuration(frames);

  var prepare = () => {
    render(currentTime, currentTimeIndex, frames);
  };

  var seek = function seek(time) {
    var offsetIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    currentTime = time;
    currentTimeIndex = offsetIndex;
    updateOnCurrent();
  };

  var updateOnCurrent = () => {
    var _options$onUpdate;

    render(currentTime, currentTimeIndex, frames);
    (_options$onUpdate = options.onUpdate) === null || _options$onUpdate === void 0 ? void 0 : _options$onUpdate.call(options);
  };

  var play = () => {
    var _options$onPlay;

    var start = 0;
    playing = true;
    (_options$onPlay = options.onPlay) === null || _options$onPlay === void 0 ? void 0 : _options$onPlay.call(options);

    var step = time => {
      if (!start) {
        start = time; // skip first frame

        requestAnimationFrame(step);
        return;
      }

      var diff = time - start;
      start = time;

      var _findTextStepTime = findTextStepTime(currentTime, currentTimeIndex, currentTime + diff, total, frames),
          nextTime = _findTextStepTime.nextTime,
          nextTimeIndex = _findTextStepTime.nextTimeIndex,
          pause = _findTextStepTime.pause,
          end = _findTextStepTime.end;

      currentTime = nextTime;
      currentTimeIndex = nextTimeIndex;
      updateOnCurrent();

      if (end) {
        var _options$onComplete;

        playing = false;
        (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 ? void 0 : _options$onComplete.call(options);
        return;
      }

      if (!playing || pause) {
        var _options$onPause;

        playing = false;
        (_options$onPause = options.onPause) === null || _options$onPause === void 0 ? void 0 : _options$onPause.call(options);
        return;
      }

      requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  };

  var pause = () => {
    playing = false;
  };

  var getStatus = () => ({
    playing,
    ended: currentTime === total,
    started: currentTime > 0,
    currentTime,
    currentTimeIndex,
    total
  });

  return {
    prepare,
    play,
    pause,
    seek,
    total,
    getStatus,
    __dev: {
      options,
      frames
    }
  };
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var selectElement = selector => {
  if (typeof selector === 'string') {
    var element = document.querySelector(selector);

    if (!element) {
      throw new Error("[lighting] Element (".concat(selector, ") not found"));
    }

    return element;
  }

  return selector;
};

var htmlElementRenderer = selector => {
  var element = selectElement(selector);

  var renderer = values => {
    var text = values.text,
        x = values.x,
        y = values.y,
        scale = values.scale,
        skewX = values.skewX,
        skewY = values.skewY,
        rotate = values.rotate,
        styles = _objectWithoutProperties(values, ["text", "x", "y", "scale", "skewX", "skewY", "rotate"]);

    setCssValue(element, styles);

    if (text !== undefined) {
      element.textContent = text;
    }

    var transform = getTransform({
      x,
      y,
      scale,
      skewX,
      skewY,
      rotate
    });

    if (transform) {
      setCssValue(element, {
        transform
      });
    }
  }; // @ts-ignore


  renderer.__EL = element;
  return renderer;
};

var getTransform = values => {
  var val = [];

  if (values.x !== undefined || values.y !== undefined) {
    var _values$x = values.x,
        x = _values$x === void 0 ? 0 : _values$x,
        _values$y = values.y,
        y = _values$y === void 0 ? 0 : _values$y;
    val.push("translate(".concat(x, ", ").concat(y, ")"));
  }

  if (values.rotate !== undefined) {
    val.push("rotate(".concat(values.rotate, ")"));
  }

  if (values.scale !== undefined) {
    val.push("scale(".concat(values.scale, ")"));
  }

  if (values.skewX !== undefined) {
    val.push("skewX(".concat(values.skewX, ")"));
  }

  if (values.skewY !== undefined) {
    val.push("skewY(".concat(values.skewY, ")"));
  }

  if (!val.length) {
    return undefined;
  }

  return val.join(' ');
};

var setCssValue = (el, value) => {
  Object.assign(el.style, value);
};

var trail = (target, operators) => {
  var renderer = findRenderer(target);
  return startAt => {
    var offset = startAt;
    var frames = operators.map(operator => {
      var frame = operator(offset);

      if (typeof frame === 'function') {
        frame = frame(renderer);
      }

      offset += Math.max(...frame.map(frame => frame.duration));
      return frame;
    }).flat();
    return frames;
  };
};

var findRenderer = target => {
  if (typeof target === 'function') {
    return target;
  }

  if (typeof target === 'string' || target instanceof HTMLElement) {
    return htmlElementRenderer(target);
  }

  throw new Error("[lighting:animate] Invalid renderer (".concat(target.toString(), ")"));
};

var cascade = (frames, options) => startAt => frames.flatMap((frameFn, index) => {
  var offset = options.offset(index) + startAt;
  return frameFn(offset);
});

var parallel = frames => startAt => frames.flatMap(frameFn => frameFn(startAt));

var sequence = frames => startAt => {
  var offset = startAt;
  return frames.flatMap(frameFn => {
    var frame = frameFn(offset);
    offset = totalDuration(frame);
    return frame;
  });
};

var pow = Math.pow,
    sin = Math.sin;
var PI = Math.PI;

var easeInOut = n => 0.5 * (sin((n - 0.5) * PI) + 1);

var easeIn = n => pow(n, 1.675);

var easeOut = n => 1 - pow(1 - n, 1.675);

var linear = x => x;

var fromTo = function fromTo(values, duration) {
  var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : easeInOut;
  return startAt => renderer => [{
    type: FrameType.Tween,
    startAt,
    startIndex: 0,
    duration,
    values,
    renderer,
    easing
  }];
};

var set = values => startAt => renderer => [{
  type: FrameType.Set,
  startAt,
  startIndex: 0,
  duration: 0,
  values,
  renderer
}];

var delay = duration => startAt => [{
  type: FrameType.Delay,
  startAt,
  startIndex: 0,
  duration
}];

var pause = () => startAt => [{
  type: FrameType.Pause,
  startAt,
  startIndex: 0,
  duration: 0
}];

var colorToString = color => "rgba(".concat(color.join(', '), ")");

var colorFromHEX = color => {
  var r = parseInt(color.substring(1, 3), 16);
  var g = parseInt(color.substring(3, 5), 16);
  var b = parseInt(color.substring(5, 7), 16);
  return [r, g, b, 1];
};

var colorFromRGB = color => {
  var _color$match$map = color.match(/(\d|\.)+/g).map(Number),
      _color$match$map2 = _slicedToArray(_color$match$map, 4),
      r = _color$match$map2[0],
      g = _color$match$map2[1],
      b = _color$match$map2[2],
      _color$match$map2$ = _color$match$map2[3],
      a = _color$match$map2$ === void 0 ? 1 : _color$match$map2$;

  return [r, g, b, a];
};

var getColor = color => {
  if (color.startsWith('#')) {
    if (color.length === 4) {
      var _color = _slicedToArray(color, 4),
          r = _color[1],
          g = _color[2],
          b = _color[3];

      var longHex = '#' + r + r + g + g + b + b;
      return colorFromHEX(longHex);
    }

    return colorFromHEX(color);
  }

  if (color.startsWith('rgb')) {
    return colorFromRGB(color);
  }

  throw new Error("[lighting:color] Unknown color \"".concat(color, "\", use hex, rgb or rgba"));
};

var color = (a, b) => {
  var c1 = getColor(a);
  var c2 = getColor(b);
  return p => {
    var n = limit(p);
    var c = [];

    for (var i = 0; i < 3; i++) {
      var ce1 = c1[i] * c1[i];
      var ce2 = c2[i] * c2[i];
      c[i] = Math.sqrt(n * (ce2 - ce1) + ce1) >> 0;
    }

    c[3] = (c2[3] - c1[3]) * n + c1[3];
    return colorToString(c);
  };
};

var colorChain = a => {
  var pref = a;
  return b => {
    var newVal = color(pref, b);
    pref = b;
    return newVal;
  };
};

var text = txt => n => {
  return txt.substr(0, txt.length * n);
};

var val = (a, b, suffix) => n => {
  var val = (b - a) * n + a;
  return suffix ? val + suffix : val;
};

var valChain = (a, suffix) => {
  var pref = a;
  return b => {
    var newVal = val(pref, b, suffix);
    pref = b;
    return newVal;
  };
};

export { FrameType, cascade, color, colorChain, delay, easeIn, easeInOut, easeOut, fromTo, htmlElementRenderer, lightTrails, linear, parallel, pause, sequence, set, setCssValue, shouldSkipFrame, text, trail, val, valChain };